import Form from 'components/Form';
import { IPatientInfo } from 'apis/admin/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import { IFormRegister } from 'routes/Main/type';

interface Props extends IFormRegister {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
}

const UserInfo = (props: Props) => {
  const { nurseName, register, disabled } = props;

  const infos = [
    { title: '교과목명', value: 'subject' },
    { title: '평가일', value: 'date' },
    { title: '실습 분반', value: 'class' },
    { title: '실습 조', value: 'team' },
    { title: '학번', value: 'student_number' },
    { title: '이름', value: 'name' },
  ];

  return (
    <RowContainer xs={12}>
      {infos.map(({ title, value }) =>
        title === '평가일' ? (
          <RowContent title={title} titleRatio={1} childrenRatio={5}>
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              type="date"
              {...register(`${value}`)}
              onPaste={e => e.preventDefault()}
              onKeyDown={e => {
                if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
                  e.preventDefault();
                }
              }}
              onContextMenu={e => e.preventDefault()}
            />
          </RowContent>
        ) : (
          <RowContent title={title} titleRatio={1} childrenRatio={5}>
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              {...register(`${value}`)}
              onPaste={e => e.preventDefault()}
              onKeyDown={e => {
                if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
                  e.preventDefault();
                }
              }}
              onContextMenu={e => e.preventDefault()}
            />
          </RowContent>
        )
      )}
    </RowContainer>
  );
};

export default UserInfo;
